import * as React from 'react'

import { cn } from '../lib/cn'

// Not `Alert`, which interrupts. A callout explains a rule or a standing state — «Un account,
// non un ruolo», «Da aggiornare» — with, in `actions`, what the reader can do about it.

// `title` is omitted from the native attributes: there it is the tooltip string, here it is
// the heading, and the two would collide on the same name.
export interface CalloutProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  title: React.ReactNode
  variant?: 'neutral' | 'warning'
  /** Buttons under the text, for a callout the reader can act on. */
  actions?: React.ReactNode
}

const SURFACES = {
  neutral: 'border-border bg-background',
  warning: 'border-warning bg-background',
} as const

export function Callout({
  title,
  variant = 'neutral',
  actions,
  className,
  children,
  ...props
}: CalloutProps) {
  return (
    <div
      data-surface="ink"
      className={cn('flex flex-col gap-1 rounded-md border p-4', SURFACES[variant], className)}
      {...props}
    >
      <span className="text-section-title">{title}</span>
      <span className="text-note text-muted-foreground">{children}</span>
      {actions == null ? null : <div className="mt-2 flex flex-wrap gap-2">{actions}</div>}
    </div>
  )
}
